import { localAESStorage } from "@/util/storage";
import { getUrlParam } from "@/handle/util/toolUtil";
import { isUrlReg } from "@/handle/util/regUtil";
import { isUndefined } from "__barrel_optimize__?names=isUndefined!=!lodash-es";
/**
 * [获取之前存储的链接]
 *
 * @export
 */
export function handleGetPreUrlParam() {
  return localStorage.getItem("historyUrl");
}
/**
 * [清除存储的上一个路由信息]
 *
 * @export
 */
export function handleClearPreUrlParam() {
  localStorage.setItem("historyUrl", "");
}
const HISTORY_URL_SESSION = "historyUrl";
/**
 * [存储当前 path session
 */
export function handleSavePreUrlParamSession() {
  const path = window.location.pathname;
  if (!isUndefined(path)) {
    sessionStorage.setItem(HISTORY_URL_SESSION, path);
  }
}
/**
 * [获取之前存储的 path session
 */
export function handleGetPreUrlParamSession() {
  return sessionStorage.getItem(HISTORY_URL_SESSION);
}
/**
 * [清除存储的上一个路由信息]
 */
export function handleClearPreUrlParamSession() {
  sessionStorage.removeItem(HISTORY_URL_SESSION);
}
export const stratifyUrl = text => {
  const urlRegex = isUrlReg;
  let url = urlRegex.exec(text);
  const result = [];
  // 当识别到是 url 时，进入循环 处理 url
  while (url) {
    // console.log( 'url', url)
    result.push({
      isUrl: false,
      text: text.substring(0, url.index)
    });
    result.push({
      isUrl: true,
      text: url[0]
    });
    text = text.substring(url.index + url[0].length);
    url = urlRegex.exec(text);
  }
  // 剩下的内容 判断为 TEXT
  result.push({
    isUrl: false,
    text: text
  });
  return result;
};
/**
 * 跨页面携带数据
 */
const TEMPLATE_DATA = "template_app_params_data";
export function saveAppParams(data) {
  localStorage.setItem(TEMPLATE_DATA, data);
}
export function loadAppParams() {
  const data = localStorage.getItem(TEMPLATE_DATA);
  if (data) {
    localStorage.removeItem(TEMPLATE_DATA);
    return data;
  }
}
/**
 * 删除 路由的某个search 数据
 */
export function deleteSearchKey(searchKey) {
  if (!getUrlParam(searchKey)) return;
  const search = location.search;
  const afterFilterSearch = search.split("?")[1].split("&").filter(item => {
    return item.indexOf(searchKey) == -1;
  }).join("&");
  const searchParams = afterFilterSearch ? "?" + afterFilterSearch : afterFilterSearch;
  history.replaceState({}, "", "".concat(location.pathname + searchParams));
}
/**
 * 清理 invitation 数据
 */
export function clearInvitationData() {
  deleteSearchKey("invitation");
  localAESStorage.removeItem("inviteCodeMap");
}